import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DeclarationService } from '../../services/forms.service';
import { SharingService } from 'src/app/modules/shared/shared.service';
import { SaveFormDeclarationLocalData } from '../../../dashboard/saveDeclarationdata';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DecimalPipe, CurrencyPipe, formatDate } from '@angular/common';
import {CustomSpinnerComponent} from '../../../../shared/components/custom-spinner/custom-spinner.component';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';

// import { MAT_DATE_FORMATS } from '@angular/material/core';
  import { MomentDateAdapter } from '@angular/material-moment-adapter';
  import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
// tslint:disable-next-line:no-duplicate-imports
import * as _moment from 'moment';
import * as moment from 'moment';
import { exit } from 'process';
// s
export const MY_FORMATS = {
  parse: {
    dateInput: 'DD-MM-YYYY'  
  },
  display: {
    dateInput: 'DD-MM-YYYY' ,
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};
@Component({
  selector: 'app-form3',
  templateUrl: './form3.component.html',
  styleUrls: ['./form3.component.css'],
  providers: [
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class Form3Component implements OnInit, OnDestroy {
  customSpinnerComponent = CustomSpinnerComponent;
  Form3: FormGroup;
  public remarks: any;
  public isDataEntered: boolean;
  form3Data: any;
  firstName: any;
  today = new Date();
  jstoday = '';
  lastName: any;
  date: any;
  dateformat: any;
  DateAssign: string;
  public fieldArray: Array<any> = [];
  public newAttribute: any = {};
  public countRows: number = 0;
  public fieldArraySBox: Array<any> = [];
  public newAttributeSBox: any = {};
  public countRowsSBox: number = 0;
  public countExceedError: boolean = false;
  public errorThreshold1: boolean = false;
  public errorEmptyFields1: boolean = false;
  public errorThreshold2: boolean = false;
  public errorEmptyFields2: boolean = false;
  public countExceedErrorSBox: boolean = false;
  public index: number;
  FormsData: any = [];
  saveFormDeclarationLocalData: SaveFormDeclarationLocalData;
  Declaration1Data: any;
  msgErrorNotSaved: boolean;
  clientsData: any;
  selectedDeclarationNo : number;
  isForm3Saved: boolean;
  Declaration3Data: any;
  savedForm3Data: any;
  finalDeclaration3Data: any;
  errorClickAddButton: boolean;
  clicked: boolean = false;
  minDate: Date;
  maxDate: Date;
  independantUsersEmptyError: boolean;


  constructor(private _router: Router, private translate: TranslateService, private service: DeclarationService,
    private formBuilder: FormBuilder, public sharingService: SharingService) {
    this.saveFormDeclarationLocalData = new SaveFormDeclarationLocalData();
    const currentYear = new Date().getFullYear();
this.minDate = new Date(1901, 0, 1);
this.maxDate = new Date(currentYear, new Date().getMonth(), new Date().getDate());
  }

  ngOnInit(): void {
    //Get all the Forms data - 
    this.FormsData = JSON.parse(sessionStorage.getItem("FormsData"));
    let selectedForm = JSON.parse(sessionStorage.getItem("selectedFormData"));
    this.selectedDeclarationNo = selectedForm.NoDeclaration;
      this.clientsData = JSON.parse(sessionStorage.getItem("SelectedClientData"));
    //Get Saved Data from Cache -
    this.savedForm3Data = JSON.parse(sessionStorage.getItem("SavedDeclaration3CachedData"));
    this.isForm3Saved = sessionStorage.getItem('isForm3Saved') == 'true' ? true : false;
    if (this.isForm3Saved && this.savedForm3Data !== null) {
      this.savedForm3Data.dataXML.XMLFile.Declaration.forEach(element => {
        if (element.Genre == 'C' && element.NoDeclaration == this.selectedDeclarationNo) {
          this.savedForm3Data = element;
        }
      });
      this.form3Data = this.savedForm3Data;
      var independentData = this.form3Data.independant[0].signaletique;
      this.remarks = this.form3Data.Comment;
    } else {
      var formData;
      if (this.FormsData !== null) {
        this.FormsData.forEach(element => {
          if (element.Genre == 'C' && element.NoDeclaration == this.selectedDeclarationNo) {
            formData = element;
          }
        });
      }
        this.form3Data = formData;
      var independentData = this.form3Data.independant[0].signaletique;
      this.remarks = this.form3Data.Comment;
    }

    if(independentData != null || independentData != undefined){
    independentData.forEach(element => {
      if ((element !== '') && (element != null)) {
        //Push elements for Independent Box
        if (element.TypeIdependant == "C") {
          var date = element.DateNaiss;
          if (date != null && date.length != 10) {
            this.DateAssign = this.formatDate(date.toString());
            element.DateNaiss = this.DateAssign;
          }
          this.fieldArray.push(element);
          this.countRows++;
        } else if (element.TypeIdependant == "A") {
          // Push elements for Aidant Box
          var date = element.DateNaiss;
          if (date.length != 10) {
            this.DateAssign = this.formatDate(date.toString());
            element.DateNaiss = this.DateAssign;
          }
          this.fieldArraySBox.push(element);
          this.countRowsSBox++;
        }
      }
    });
  }
  }

  onKeydown(e) {
     e = e || window.event;
    var charCode = (typeof e.which == "undefined") ? e.keyCode : e.which;
    var charStr = String.fromCharCode(charCode);
    if(e.key == '-'){
      return true;
    }
    if (/\d/.test(charStr)) {
        return false;
    }
  }
 
  addEventFBox(type: string, event: MatDatepickerInputEvent<Date>, index) {
    const dateVal = moment(new Date(event.value)).format('YYYY-MM-DD');
    
    let arrayFBox = this.fieldArray;
    arrayFBox.forEach((userC, userIndex) => {
      if (userIndex == index) {
        userC.DateNaiss = dateVal;
      }
    });
    this.fieldArray = arrayFBox;

  }
  addEventSBox(type: string, event: MatDatepickerInputEvent<Date>, index) {
    const dateVal = moment(new Date(event.value)).format('YYYY-MM-DD');
    let arraySBox = this.fieldArraySBox;
    arraySBox.forEach((userA, userIndex) => {
      if (userIndex == index) {
        userA.DateNaiss = dateVal;
      }
    });
this.fieldArraySBox = arraySBox;
  }​​

  formatDate(date) {
    if (date !== '' && date !== null) {
      if (date.length == 19) {
        var year = date.substring(0, 4);
        var month = date.substring(7, 5);
        var day = date.substring(10, 8);
        return [year, month, day].join('-');
      } else if (date.length == 8) {
        var year = date.substring(0, 4);
        var month = date.substring(6, 4);
        var day = date.slice(date.length - 2);
        return [year, month, day].join('-');
      }

    } else {
      return null;
    }
  }
  customDateFormat(date) {
    if (date !== '' && date !== null) {
      if (date.length == 19) {
        var year = date.substring(0, 4);
        var month = date.substring(7, 5);
        var day = date.substring(10, 8);
      } else if (date.length == 8) {
        var year = date.substring(0, 4); 
        var month = date.substring(6, 4);
        var day = date.slice(date.length - 2);
      }

      return [day ,month, year].join('/');
    } else {
      return null;
    }
  }


  addFieldValueFBox() {

    if ((this.newAttribute.Nom != "" && this.newAttribute.Nom != undefined) &&
      (this.newAttribute.Prenom != "" && this.newAttribute.Prenom != undefined) &&
      (this.newAttribute.DateNaiss != "" && this.newAttribute.DateNaiss != undefined)) {
      if (this.countRows < 15) {
        this.isDataEntered = true;
        this.newAttribute.TypeIdependant = "C";
        this.newAttribute.CodeTypeIdependant = '';
        let date = this.newAttribute.DateNaiss;
        const dateVal = moment(new Date(date)).format('YYYY-MM-DD');
        this.newAttribute.DateNaiss = dateVal;
        this.fieldArray.push(this.newAttribute);
        this.countRows++;
        this.newAttribute = {};
        this.errorEmptyFields1 = false;
        this.errorThreshold1 = false;
        this.errorClickAddButton = false;
      } else {
        this.errorThreshold1 = true;
        this.errorClickAddButton = false;
        this.errorEmptyFields1 = false;
      }
    } else {
      this.errorEmptyFields1 = true;
    }
  }
  addFieldValueSBox() {
    if ((this.newAttributeSBox.Nom != "" && this.newAttributeSBox.Nom != undefined) && 
    (this.newAttributeSBox.Prenom != "" && this.newAttributeSBox.Prenom != undefined)
      && (this.newAttributeSBox.DateNaiss != "" && this.newAttributeSBox.DateNaiss != undefined)) {
      if (this.countRowsSBox < 10) {
        this.isDataEntered = true;
        this.newAttributeSBox.TypeIdependant = "A";
        this.newAttributeSBox.CodeTypeIdependant = '';
        let date = this.newAttributeSBox.DateNaiss;
        const dateVal = moment(new Date(date)).format('YYYY-MM-DD');
        this.newAttributeSBox.DateNaiss = dateVal;
        this.fieldArraySBox.push(this.newAttributeSBox);
        this.newAttributeSBox = {};
        this.countRowsSBox++;
        this.errorEmptyFields2 = false;
        this.errorThreshold2 = false;
        this.errorClickAddButton = false;
      } else {
        this.errorThreshold2 = true;
        this.errorClickAddButton = false;
        this.errorEmptyFields2 = false;
      }
    } else {
      this.errorEmptyFields2 = true;
    }
  }

  deleteFirstboxFieldValue(index) {
    this.fieldArray.splice(index, 1);
    this.countRows--;
    this.index = index + 1;
    this.isDataEntered = true;

    this.errorEmptyFields1 = false;
    this.errorThreshold1 = false;

  }
  deleteSecondBoxFieldValue(index) {
    this.fieldArraySBox.splice(index, 1);
    this.countRowsSBox--;
    this.index = index + 1;
    this.isDataEntered = true;

    this.errorEmptyFields2 = false;
    this.errorThreshold2 = false;

  }
  dataEntered() {
    if ((this.remarks !== null && this.remarks !== undefined) ||
      (this.newAttributeSBox.Nom != undefined || this.newAttributeSBox.Prenom != undefined || this.newAttributeSBox.DateNaiss != undefined) ||
      (this.newAttribute.Nom != undefined || this.newAttribute.Prenom != undefined || this.newAttribute.DateNaiss != undefined)) {
      this.isDataEntered = true;
    }
  }

  ValidateAndSaveForm3() {
    this.msgErrorNotSaved = false;
    let isFBoxEmpty;
    let isSBoxEmpty;
    this.fieldArray.forEach( item =>{
      if((item.Nom != "" && item.Nom != undefined) &&
      (item.Prenom != "" && item.Prenom != undefined) &&
      (item.DateNaiss != "" && item.DateNaiss != undefined)){
         isFBoxEmpty = false;
      }else{
        isFBoxEmpty = true;
      }
    });

    this.fieldArraySBox.forEach( item =>{
      if((item.Nom != "" && item.Nom != undefined) &&
      (item.Prenom != "" && item.Prenom != undefined) &&
      (item.DateNaiss != "" && item.DateNaiss != undefined)){
        isSBoxEmpty = false;
      }else{
        isSBoxEmpty = true;
      }
    });
    
    if (isFBoxEmpty) {
      this.errorEmptyFields1 = true;
      this.errorEmptyFields2 = false;
    }else if(isSBoxEmpty){
      this.errorEmptyFields1 = false;
      this.errorEmptyFields2 = true;
    }else{
    if ((this.newAttribute.Nom != "" && this.newAttribute.Nom != undefined) ||
      (this.newAttribute.Prenom != "" && this.newAttribute.Prenom != undefined) ||
      (this.newAttribute.DateNaiss != "" && this.newAttribute.DateNaiss != undefined) ||
      (this.newAttributeSBox.Nom != "" && this.newAttributeSBox.Nom != undefined) ||
      (this.newAttributeSBox.Prenom != "" && this.newAttributeSBox.Prenom != undefined) ||
      (this.newAttributeSBox.DateNaiss != "" && this.newAttributeSBox.DateNaiss != undefined)) {
        
      this.errorClickAddButton = true;
      this.countExceedErrorSBox = false;
      this.errorEmptyFields2 = false;
      this.errorThreshold2 = false;
    } else {

    this.PrepareDeclarationData();
    var JsonForm3SaveDeclaration = JSON.stringify(this.finalDeclaration3Data);
      if (JsonForm3SaveDeclaration != undefined) {
        this.Declaration3Data = JSON.parse(JsonForm3SaveDeclaration);
      } else {
        return;
      }
    this.service.SaveDeclaration1(this.Declaration3Data).subscribe(
      (data) => {
        if (data == 'Failed') {
          this.msgErrorNotSaved = true;
          sessionStorage.setItem('isForm3Saved', 'false');
        }
        else {
          sessionStorage.setItem("FormsData", JSON.stringify(this.FormsData));
          sessionStorage.setItem("AllDeclarationData", JsonForm3SaveDeclaration);
          sessionStorage.setItem('isForm3Saved', 'true');
          sessionStorage.setItem("SavedDeclaration3CachedData", JsonForm3SaveDeclaration);
          sessionStorage.setItem('form3SubmittedDate', formatDate(this.today, 'dd/MM/yyyy', 'en-US', '+0100'));
          this.msgErrorNotSaved = false;
          this.gotoDashboard();
        }
      },
      (err) => {
        this.msgErrorNotSaved = true;
      });
              
    }
  }
  }
  PrepareDeclarationData() {
    var declaration3Data = {
      FormType: "",
      FormSubType: "",
      ContractNummer: "",
      AccountNumber: "",
      User: 0,
      dataXML: {
        XMLFile: {
          Header:
          {
            QualCiv: "",
            Nom: "",
            Prenom: "",
            NoClient: 0,
            RegimeLinguistique: 0,
            Email: "",
            Rue: "",
            NoRue: "",
            CodePostal: 0,
            Localite: "",
            LibellePays: ""
          },
          Declaration: [
            {
              Comment: "",
              contrat: [],
              Exercice: 0,
              PeriodeDebut: "",
              PeriodeFin: "",
              NoDeclaration: 0,
              NoProgressif: 0,
              Genre: "",
              noIntervenantDestinataire: 0,
              NomDestinataire: "",
              PrenomDestinataire: "",
              RoleDestinataire: "",
              Statut: "",
              Libelle: "",
              CodeMontantBrut: "",
              MontantBrut: 0,
              CodeMontantNet: '',
              MontantNet: 0,
              CodeMontantTVA: '',
              MontantTVA: 0,
              TVAApplicable: 1,
              CodeActivite: "",
              Activite: [],
              CodePourcentTot: 0,
              independant: [{
                NbrIndependantTot: 0,
                CodeIndependantTot: "CCHEFNBR",
                NbrAidantTot: 0,
                CodeAidantTot: "CASSISNBR",
                signaletique: []
              }
              ],
              LastModifiedDate : ""
            }
          ]
        }
      }
    }

    declaration3Data.dataXML.XMLFile.Header.NoClient = parseInt(sessionStorage.getItem('ClientNo'));
    declaration3Data.dataXML.XMLFile.Header.Email = sessionStorage.getItem('NewEmail') != null ? sessionStorage.getItem('NewEmail'):sessionStorage.getItem('Email');
    declaration3Data.dataXML.XMLFile.Header.CodePostal = this.clientsData.CodePostal;
    declaration3Data.dataXML.XMLFile.Header.LibellePays = this.clientsData.LibellePays;
    declaration3Data.dataXML.XMLFile.Header.Localite = this.clientsData.Localite;
    declaration3Data.dataXML.XMLFile.Header.Rue = this.clientsData.Rue;
    declaration3Data.dataXML.XMLFile.Header.NoRue = this.clientsData.NoRue;
    declaration3Data.dataXML.XMLFile.Header.QualCiv = this.clientsData.QualCiv;
    declaration3Data.dataXML.XMLFile.Header.RegimeLinguistique = sessionStorage.getItem("currentlang") === 'FR' ? 1 : 2;
    declaration3Data.dataXML.XMLFile.Header.Nom = this.clientsData.Nom;
    declaration3Data.dataXML.XMLFile.Header.Prenom = this.clientsData.Prenom;
    // Prepare DECLARATION Data -
    declaration3Data.FormType = 'DECL_ON_2020';
    // this.progressIfNo = this.Form2Data;    // this.branchNo =    ;// this.contractNo =  ;
    declaration3Data.FormSubType = 'FORM'; //: FORMX/DECL number/ progressif /genre 
    declaration3Data.ContractNummer = '';//yet to get : Branch "/" Contract number” 
    declaration3Data.AccountNumber = sessionStorage.getItem('ClientNo'); //d.	(NoClient=No matricule of the client
    declaration3Data.User = 0; //yet to get from -  RetrieveDeclarationParClient
    declaration3Data.dataXML.XMLFile.Declaration[0].Comment = this.remarks != undefined ? this.remarks.toString() : "";
    declaration3Data.dataXML.XMLFile.Declaration[0].Genre = "C";
    declaration3Data.dataXML.XMLFile.Declaration[0].NoDeclaration = this.selectedDeclarationNo;
    declaration3Data.dataXML.XMLFile.Declaration[0].LastModifiedDate = formatDate(this.today, 'dd/MM/yyyy', 'en-US', '+0100');
    declaration3Data.dataXML.XMLFile.Declaration[0].Exercice = parseInt(sessionStorage.getItem("Year"));
    declaration3Data.dataXML.XMLFile.Declaration[0].noIntervenantDestinataire = this.form3Data.noIntervenantDestinataire;
    declaration3Data.dataXML.XMLFile.Declaration[0].RoleDestinataire = this.form3Data.RoleDestinataire;
    declaration3Data.dataXML.XMLFile.Declaration[0].NoDeclaration = this.form3Data.NoDeclaration;
    declaration3Data.dataXML.XMLFile.Declaration[0].NomDestinataire = this.form3Data.NomDestinataire;
    declaration3Data.dataXML.XMLFile.Declaration[0].NoProgressif = this.form3Data.NoProgressif;
    declaration3Data.dataXML.XMLFile.Declaration[0].PeriodeDebut = this.form3Data.PeriodeDebut == null ? "" :
      (this.form3Data.PeriodeDebut.length == 10 ? this.form3Data.PeriodeDebut : this.customDateFormat(this.form3Data.PeriodeDebut));
    declaration3Data.dataXML.XMLFile.Declaration[0].PeriodeFin = this.form3Data.PeriodeFin == null ? "" :
      (this.form3Data.PeriodeFin.length == 10 ? this.form3Data.PeriodeFin : this.customDateFormat(this.form3Data.PeriodeFin));
    declaration3Data.dataXML.XMLFile.Declaration[0].Statut = "ACTIVE";
    declaration3Data.dataXML.XMLFile.Declaration[0].independant[0].NbrIndependantTot = this.countRows;
    declaration3Data.dataXML.XMLFile.Declaration[0].independant[0].NbrAidantTot = this.countRowsSBox;
    var contractData = [];
    if (this.isForm3Saved && this.savedForm3Data !== null) {
      this.form3Data.contrat.forEach(element => {
        contractData.push(element);
      });
    } else {
      this.form3Data.contrat.forEach(element => {
        contractData.push(element);
      });
    }
    declaration3Data.dataXML.XMLFile.Declaration[0].contrat = contractData;

    var form3AppendedData = [];
    if (this.fieldArray != null || this.fieldArray != undefined || this.fieldArray != []) {
      if (this.fieldArray.length !== 0) {
        this.independantUsersEmptyError = false;
        this.fieldArray.forEach(itemTypeC => {
          itemTypeC.Nom = itemTypeC.Nom != undefined  && itemTypeC.Nom != null ? itemTypeC.Nom.trim()  : itemTypeC.Nom;
          itemTypeC.Prenom = itemTypeC.Prenom != undefined  && itemTypeC.Prenom != null ? itemTypeC.Prenom.trim()  : itemTypeC.Prenom;
          form3AppendedData.push(itemTypeC);
        });
      } else {
        this.independantUsersEmptyError = true;
        return;
      }
    } else {
      this.independantUsersEmptyError = true;
      return;
    }
    this.fieldArraySBox.forEach(itemTypeA => {
      itemTypeA.Nom = itemTypeA.Nom != undefined  && itemTypeA.Nom != null ? itemTypeA.Nom.trim()  : itemTypeA.Nom;
      itemTypeA.Prenom = itemTypeA.Prenom != undefined  && itemTypeA.Prenom != null ? itemTypeA.Prenom.trim()  : itemTypeA.Prenom;
      form3AppendedData.push(itemTypeA);
    })
    form3AppendedData.forEach(item => {
      declaration3Data.dataXML.XMLFile.Declaration[0].independant[0].signaletique.push(item);
    });
    var signaletique = [];
    declaration3Data.dataXML.XMLFile.Declaration[0].independant[0].signaletique.forEach(e => {
      signaletique.push(e);
    });
    if (this.FormsData !== null) {
      this.FormsData.forEach(element => {
        if (element.Genre != "C" && element.NoDeclaration != this.selectedDeclarationNo) {
          declaration3Data.dataXML.XMLFile.Declaration.push(element);
        }
      });
    }
    this.FormsData = declaration3Data.dataXML.XMLFile.Declaration;
    this.finalDeclaration3Data = declaration3Data;
  }
  ngOnDestroy(): void {
    sessionStorage.removeItem("selectedFormData");
    this.countRows = 0;
    this.fieldArray = [];
    this.fieldArraySBox = [];
    this.countRowsSBox = 0;
  }
  gotoDashboard() {
    this._router.navigate(['/dashboard']);
  }

}
